// @ts-ignore
import { getUserData } from "@/auth/getUserData";

export const resolveVariables = (message: string): string => {
    // @NOTICE according to the email channel settings, we can only add "agent.fullname" and "agent.displayname".
    const systemVariables: { [key: string]: string } = {
        "agent.fullname": getUserData().name || "{{agent.fullname}}",
        "agent.displayname": getUserData().displayName || "{{agent.displayname}}",
        // "agent.name": getUserData().name || "{{agent.name}}",
        // "customer.fullname":
        //     this.$store.state.identities.currentIdentity.contact.name ||
        //     "{{customer.fullname}}",
        // "customer.phone":
        //     this.$store.state.identities.currentIdentity.contact.phone ||
        //     "{{customer.phone}}",
        // "customer.email":
        //     this.$store.state.identities.currentIdentity.contact.email ||
        //     "{{customer.email}}",
        // "customer.reference":
        //     this.$store.state.identities.currentIdentity.contact.reference ||
        //     "{{customer.reference}}",
        // "customer.jobtitle":
        //     this.$store.state.identities.currentIdentity.contact.jobTitle ||
        //     "{{customer.jobtitle}}",
        // "customer.company":
        //     this.$store.state.identities.currentIdentity.contact.company ||
        //     "{{customer.company}}",
    };

    return message.replace(/{{\s*([^\s{}]+)\s*}}/gi, (_match, variableKey) => systemVariables[variableKey] || _match);
};
